export default "__VITE_ASSET__780d0237__"